import { render, staticRenderFns } from "./DetectionMapChart.vue?vue&type=template&id=9a67c1da"
import script from "./DetectionMapChart.vue?vue&type=script&lang=js"
export * from "./DetectionMapChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports